import { render, staticRenderFns } from "./ChannelGroupDeleteModal.vue?vue&type=template&id=2437c2f4&"
import script from "./ChannelGroupDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./ChannelGroupDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports